import React from "react";
import LayoutTemplate from "./LayoutPages/LayoutTemplate";

const AdminLayout = ({ children }) => {
  return <LayoutTemplate>{children}</LayoutTemplate>;
};

export default AdminLayout;
